<rlst-modal header="Confirm Before Proceeding" (closeModal)="cancel()" class="modal-content" [isNewModal]="true" rlstTooltip="Close">

  <div>
    <div class="card-body content">
      <div>
        <div>This is a digital product. Once viewed or downloaded, the report will be accessible and returns can no longer be processed.</div>
        <div class="space"></div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="actions-panel right">
      <button
        (click)="goToReport()"
        class="btn btn-custom-dark justify-content-center">
        Confirm
      </button>
  </div>

</rlst-modal>
